import * as constants from "./constants";
export const initialState = {
  // Nouveau state pour la vérification de crédit
  creditLoading: false,
  creditData: null,
  creditError: null,
  hasInsufficientCredit: false, // Flag pour afficher le modal de crédit

  //search
  searchLoading: false,
  search: [],
  isMakeSearch: false,
  searchError: null,

  //search detail
  searchDetailLoading: false,
  searchDetail: null,
  searchDetailError: null,

  //Decision pour le demandeur
  searchDecisionApplicantsLoading: false,
  searchDecisionApplicants: [],
  searchDecisionApplicantsError: null,

  searchAnnoncesPaginateLoading: false,
  searchMarchesPublicsPaginateLoading: false,

  //Decision pour le defendeur
  searchDecisionDefendantsLoading: false,
  searchDecisionDefendants: [],
  searchDecisionDefendantsError: null,

  //Autre decision pour le demandeur
  searchOthersApplicantsLoading: false,
  searchOthersApplicants: [],
  searchOthersApplicantsError: null,

  //Autre decision pour le defendeur
  searchOthersDefendantsLoading: false,
  searchOthersDefendants: [],
  searchOthersDefendantsError: null,

  //search detail dirigeants
  searchDirigeantsDetailLoading: false,
  searchDirigeantsDetail: [],
  searchDirigeantsDetailError: null,

  //search for chart
  cart: [],
  isLoadingCart: false,

  //Annonces légales
  searchAnnoncesLoading: false,
  searchAnnonces: null,
  searchAnnoncesError: null,

  //Marchés publics
  searchMarchesPublicsLoading: false,
  searchMarchesPublics: null,
  searchMarchesPublicsError: null,
};
const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    // Nouveau case pour la vérification de crédit
    case constants.CHECK_CREDIT_REQUESTING:
      return {
        ...state,
        creditLoading: true,
        searchLoading: true, // On met aussi searchLoading à true pour l'UX
        hasInsufficientCredit: false,
        creditError: null,
      };

    case constants.CHECK_CREDIT_SUCCESS:
      return {
        ...state,
        creditLoading: false,
        creditData: action?.payload,
        creditError: null,
        hasInsufficientCredit: false,
      };

    case constants.CHECK_CREDIT_FAILED:
      return {
        ...state,
        creditLoading: false,
        searchLoading: false,
        creditData: null,
        creditError: action.error,
        hasInsufficientCredit: false,
      };

    case constants.CHECK_CREDIT_INSUFFICIENT:
      return {
        ...state,
        creditLoading: false,
        searchLoading: false,
        creditData: action?.payload,
        hasInsufficientCredit: true, // Flag pour afficher le modal
        isMakeSearch: true,
      };

    case constants.RESET_CREDIT_STATUS:
      return {
        ...state,
        hasInsufficientCredit: false,
        creditError: null,
      };

    case constants.SEARCH_REQUESTING:
      return {
        ...state,
        searchLoading: true,
      };
    case constants.SEARCH_REQUESTING_ALERTE:
      return {
        ...state,
        searchLoading: true,
      };
    case constants.SEARCH_SUCCESS:
      return {
        ...state,
        searchLoading: false,
        isMakeSearch: true,
        search: action?.payload,
        searchError: null,
      };
    case constants.SEARCH_EMPTY:
      return {
        ...state,
        searchLoading: false,
        isMakeSearch: true,
        search: [],
        searchError: null,
      };
    case constants.SEARCH_FAILED:
      return {
        ...state,
        searchLoading: false,
        isMakeSearch: true,
        search: [],
        searchError: action.error,
      };
    //Detail for search
    case constants.SEARCH_DETAIL_REQUESTING:
      return {
        ...state,
        searchDetailLoading: true,
      };

    case constants.SEARCH_DETAIL_SUCCESS:
      return {
        ...state,
        searchDetailLoading: false,
        searchDetail: action?.payload,
        searchDetailError: null,
      };

    case constants.SEARCH_DETAIL_FAILED:
      return {
        ...state,
        searchDetailLoading: false,
        searchDetail: null,
        searchDetailError: action.error,
      };

    case constants.RESET_SEARCH_DETAIL_STATE:
      return {
        ...state,
        // Réinitialiser les détails de l'entreprise
        searchDetail: null,
        searchDetailError: null,
        // Réinitialiser les décisions
        searchDecisionApplicants: [],
        searchDecisionApplicantsError: null,
        searchDecisionDefendants: [],
        searchDecisionDefendantsError: null,
        searchOthersApplicants: [],
        searchOthersApplicantsError: null,
        searchOthersDefendants: [],
        searchOthersDefendantsError: null,
        // Réinitialiser les dirigeants
        searchDirigeantsDetail: [],
        searchDirigeantsDetailError: null,
        // Réinitialiser les annonces légales
        searchAnnonces: null,
        searchAnnoncesError: null,
        // Réinitialiser les marchés publics
        searchMarchesPublics: null,
        searchMarchesPublicsError: null,
      };

    //Decision pour le demandeur
    case constants.SEARCH_DECISION_APPLICANTS_REQUESTING:
    case constants.PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING:
      return {
        ...state,
        searchDecisionApplicantsLoading: true,
      };

    case constants.SEARCH_DECISION_APPLICANTS_SUCCESS:
    case constants.PAGINATE_SEARCH_DECISION_APPLICANTS_SUCCESS:
      return {
        ...state,
        searchDecisionApplicantsLoading: false,
        searchDecisionApplicants: action?.payload,
        searchDecisionApplicantsError: null,
      };

    case constants.SEARCH_DECISION_APPLICANTS_FAILED:
    case constants.PAGINATE_SEARCH_DECISION_APPLICANTS_FAILED:
      return {
        ...state,
        searchDecisionApplicantsLoading: false,
        searchDecisionApplicants: [],
        searchDecisionApplicantsError: action.error,
      };

    //Decision pour le defendeur
    case constants.SEARCH_DECISION_DEFENDANTS_REQUESTING:
    case constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_REQUESTING:
      return {
        ...state,
        searchDecisionDefendantsLoading: true,
      };

    case constants.SEARCH_DECISION_DEFENDANTS_SUCCESS:
    case constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_SUCCESS:
      return {
        ...state,
        searchDecisionDefendantsLoading: false,
        searchDecisionDefendants: action?.payload,
        searchDecisionDefendantsError: null,
      };

    case constants.SEARCH_DECISION_DEFENDANTS_FAILED:
    case constants.PAGINATE_SEARCH_DECISION_DEFENDANTS_FAILED:
      return {
        ...state,
        searchDecisionDefendantsLoading: false,
        searchDecisionDefendants: [],
        searchDecisionDefendantsError: action.error,
      };

    //Autre decision pour le demandeur
    case constants.SEARCH_OTHERS_APPLICANTS_REQUESTING:
    case constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_REQUESTING:
      return {
        ...state,
        searchOthersApplicantsLoading: true,
      };

    case constants.SEARCH_OTHERS_APPLICANTS_SUCCESS:
    case constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_SUCCESS:
      return {
        ...state,
        searchOthersApplicantsLoading: false,
        searchOthersApplicants: action?.payload,
        searchOthersApplicantsError: null,
      };

    case constants.SEARCH_OTHERS_APPLICANTS_FAILED:
    case constants.PAGINATE_SEARCH_OTHERS_APPLICANTS_FAILED:
      return {
        ...state,
        searchOthersApplicantsLoading: false,
        searchOthersApplicants: [],
        searchOthersApplicantsError: action.error,
      };

    //Autre Decision pour le defendeur
    case constants.SEARCH_OTHERS_DEFENDANTS_REQUESTING:
    case constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_REQUESTING:
      return {
        ...state,
        searchOthersDefendantsLoading: true,
      };

    case constants.SEARCH_OTHERS_DEFENDANTS_SUCCESS:
    case constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_SUCCESS:
      return {
        ...state,
        searchOthersDefendantsLoading: false,
        searchOthersDefendants: action?.payload,
        searchOthersDefendantsError: null,
      };

    case constants.SEARCH_OTHERS_DEFENDANTS_FAILED:
    case constants.PAGINATE_SEARCH_OTHERS_DEFENDANTS_FAILED:
      return {
        ...state,
        searchOthersDefendantsLoading: false,
        searchOthersDefendants: [],
        searchOthersDefendantsError: action.error,
      };

    //Detail for dirigeant search
    case constants.SEARCH_DETAIL_DIRIGEANTS_REQUESTING:
      return {
        ...state,
        searchDirigeantsDetailLoading: true,
      };
    case constants.SEARCH_DETAIL_DIRIGEANTS_SUCCESS:
      return {
        ...state,
        searchDirigeantsDetailLoading: false,
        searchDirigeantsDetail: action?.payload,
        searchDirigeantsDetailError: null,
      };
    case constants.SEARCH_DETAIL_DIRIGEANTS_FAILED:
      return {
        ...state,
        searchDirigeantsDetailLoading: false,
        searchDirigeantsDetail: [],
        searchDirigeantsDetailError: action.error,
      };

    //Annonces légales
    case constants.SEARCH_ANNONCES_REQUESTING:
      return {
        ...state,
        searchAnnoncesLoading: true,
      };
    case constants.SEARCH_ANNONCES_SUCCESS:
      return {
        ...state,
        searchAnnoncesLoading: false,
        searchAnnonces: action?.payload,
        searchAnnoncesError: null,
      };
    case constants.SEARCH_ANNONCES_FAILED:
      return {
        ...state,
        searchAnnoncesLoading: false,
        searchAnnonces: null,
        searchAnnoncesError: action.error,
      };

    //Marchés publics
    case constants.SEARCH_MARCHES_PUBLICS_REQUESTING:
      return {
        ...state,
        searchMarchesPublicsLoading: true,
      };
    case constants.SEARCH_MARCHES_PUBLICS_SUCCESS:
      return {
        ...state,
        searchMarchesPublicsLoading: false,
        searchMarchesPublics: action?.payload,
        searchMarchesPublicsError: null,
      };
    case constants.SEARCH_MARCHES_PUBLICS_FAILED:
      return {
        ...state,
        searchMarchesPublicsLoading: false,
        searchMarchesPublics: null,
        searchMarchesPublicsError: action.error,
      };

    // Pagination Annonces légales
    case constants.PAGINATE_SEARCH_ANNONCES_REQUESTING:
      return {
        ...state,
        searchAnnoncesPaginateLoading: true,
      };
    case constants.PAGINATE_SEARCH_ANNONCES_SUCCESS:
      return {
        ...state,
        searchAnnoncesPaginateLoading: false,
        searchAnnonces: action?.payload,
        searchAnnoncesError: null,
      };
    case constants.PAGINATE_SEARCH_ANNONCES_FAILED:
      return {
        ...state,
        searchAnnoncesPaginateLoading: false,
        searchAnnoncesError: action.error,
      };

    // Pagination Marchés publics
    case constants.PAGINATE_SEARCH_MARCHES_PUBLICS_REQUESTING:
      return {
        ...state,
        searchMarchesPublicsPaginateLoading: true,
      };
    case constants.PAGINATE_SEARCH_MARCHES_PUBLICS_SUCCESS:
      return {
        ...state,
        searchMarchesPublicsPaginateLoading: false,
        searchMarchesPublics: action?.payload,
        searchMarchesPublicsError: null,
      };
    case constants.PAGINATE_SEARCH_MARCHES_PUBLICS_FAILED:
      return {
        ...state,
        searchMarchesPublicsPaginateLoading: false,
        searchMarchesPublicsError: action.error,
      };

    default:
      return state;
  }
};

export default searchReducer;